import { Client } from "../../../../axios";
export const submitFormData = async ({ payload }) => {

  const res = await Client.post(
    `uudesr/design-requisition/request`,
    payload
  );
  return res.data.data;

}